<template>
  <div class="step-list">
    <h5 class="title">{{ title }}</h5>
    <step v-for="(description, index) in steps" :key="index" :indicator="index+1" :description="description" />
  </div>
</template>

<script>
import Step from './Step.vue'
export default {
  components: {
    Step
  },
  props: {
    title: String,
    steps: Array
  }
}
</script>

<style lang="scss">
.step-list {
    h5.title {
        color: #4B68EE;
        font-size: 16px;
        font-weight: bold;
    }
}
</style>
